import { useAccountState } from 'contexts/account/account-context';
import { usePondsState } from 'views/production-systems/context/ponds-context';
import { Dayjs } from 'dayjs';
import React from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

type ParamTypes = {
  globalSiteId: string;
};

type Props = {
  dateCreated?: Dayjs;
};

const RegistrationHeader: React.FC<Props> = ({ dateCreated }) => {
  const { account } = useAccountState();
  const { registrationDate } = usePondsState();
  const params = useParams<ParamTypes>();
  const intl = useIntl();

  return (
    <Box mb={4} display="flex" justifyContent="space-between">
      <Typography variant="h6">
        {intl.formatMessage({ id: 'productionSystems.selectedFarm' })}
        {account.company?.addressAccess.find((s) => s.id === params.globalSiteId)?.name}
      </Typography>
      <Typography variant="h6">
        {intl.formatMessage({ id: 'productionSystems.selectedDate' })}{' '}
        {dateCreated === undefined ? registrationDate.format('DD/MM/YYYY') : dateCreated.format('DD/MM/YYYY')}
      </Typography>
    </Box>
  );
};

export default React.memo(RegistrationHeader);
